import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M22 5V2l-5.89 5.89", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "16.6", cy: "15.89", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "8.11", cy: "7.4", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12.35", cy: "11.65", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "13.91", cy: "5.85", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "18.15", cy: "10.09", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "6.56", cy: "13.2", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "10.8", cy: "17.44", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "5", cy: "19", r: "3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Grape";
const Grape = memo(themed(Icon));
export {
  Grape
};
//# sourceMappingURL=grape.js.map
